import {GenericService} from '@/shared/xhttp';
import {Achat} from '@/models';

export class AchatService extends GenericService<Achat> {

	public putMarkPaid(achat: Achat) {
		this.put(`/${achat.id}/mark-paid`);
	}
	public putFinCoupe(achat: Achat) {
		this.put(`/${achat.id}/fin-coupe`);
	}
}